<template>
	<div class="subject-container">
		<!-- 顶部搜索 + 操作 -->
		<div class="header-box">
			<el-button type="primary" @click="openAdd">+ 新增学期</el-button>
		</div>

		<!-- 列表 -->
		<el-table :data="list" border stripe>
			<el-table-column label="ID" prop="id" width="80" align="center" />
			<el-table-column label="年份" prop="year" align="center" />
			<el-table-column label="学期类型" align="center">
				<template #default="{row}">
					{{ row.term == 1 ? '上学期' : '下学期' }}
				</template>
			</el-table-column>
			<el-table-column label="开始时间" align="center">
				<template #default="{row}">
					{{ formDate(row.startTime)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间" align="center">
				<template #default="{row}">
					{{ formDate(row.endTime)}}
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<template #default="{row}">
					{{row.status===0?"未开始":row.status===1?"开始":"已结束"}}
				</template>
			</el-table-column>
			<el-table-column label="默认开校创建" align="center" width="200">
				<template #default="{row}">
					<el-switch v-model="row.defaultCreate" :active-value="1" :inactive-value="0"
						@change="updateStatus(row)" active-text="创建" inactive-text="不创建" />
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template #default="{row}">
					<el-button v-if="row.status!=2" size="mini" type="primary" @click="openEdit(row)">编辑</el-button>
					<el-button v-if="row.status!=2" size="mini" type="primary" @click="getAdminSemesterBatch(row)">同步学期</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination v-model:current-page="pageNum" :total="total" layout="total, prev, pager, next, jumper"
			@current-change="getList" style="margin-top:16px;text-align:right" />

		<!-- 新增/编辑弹窗 -->
		<el-dialog :visible.sync="dialogVisible" title="学期信息" width="700px">
			<el-form :model="form" ref="formRef" label-width="120px">
				<el-form-item label="年份" prop="year">
					<el-input v-model="form.year" style="width:300px" placeholder="例如：2025" />
				</el-form-item>

				<el-form-item label="学期类型">
					<el-radio-group v-model="form.term">
						<el-radio :label="1">上学期</el-radio>
						<el-radio :label="2">下学期</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="开始时间">
					<el-date-picker value-format="timestamp" type="date" v-model="form.startTime" placeholder="选择开始日期"
						style="width:300px" />
				</el-form-item>

				<el-form-item label="结束时间">
					<el-date-picker value-format="timestamp" type="date" v-model="form.endTime" placeholder="选择结束日期"
						style="width:300px" />
				</el-form-item>

				<el-form-item label="状态">
					<el-radio-group v-model="form.status">
						<el-radio :label="0">未开始</el-radio>
						<el-radio :label="1">默认学期</el-radio>
						<el-radio :label="2">已结束</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="默认开校创建">
					<el-radio-group v-model="form.defaultCreate">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'SemesterManage',
		data() {
			return {
				dialogVisible: false,
				form: {
					id: null,
					year: '',
					term: 1,
					startTime: '',
					endTime: '',
					status: 0,
					defaultCreate: 0
				},
				pageSize: 10,
				pageNum: 1,
				total: 0,
				list: [],
				endTime:'',
				login:null,
			}
		},
		created() {
			this.getList()
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			formDate(val) {
				if (!val) return ''
				let date = new Date(val)
				let year = date.getFullYear()
				let month = (date.getMonth() + 1).toString().padStart(2, '0')
				let day = date.getDate().toString().padStart(2, '0')
				return year + '-' + month + '-' + day
			},
			formatEndTime(timestamp) {
				if (!timestamp) return ''
				let date = new Date(timestamp)
				// 先设置到 23:59:59
				date.setHours(23)
				date.setMinutes(59)
				date.setSeconds(59)
				return date.getTime()
			},
			// 打开新增
			openAdd() {
				
				this.form = {
					id: null,
					year: '',
					term: 1,
					startTime: this.endTime,
					endTime: '',
					status: 0,
					defaultCreate: 0
				}
				this.dialogVisible = true
			},

			// 打开编辑
			openEdit(row) {
				this.form = {
					...row
				}
				this.dialogVisible = true
			},

			// 获取列表
			async getList(pange) {
				if (pange) {
					this.pageNum = pange
				}
				try {
					let res = await this.API.get(this.API.admin.getAdminSemesterList, {
						pageSize: this.pageSize,
						pageNum: this.pageNum
					})
					console.log('res', res.data)
					this.list = res.data.data.records || []
					this.total = res.data.data.total
					this.list=this.list?.sort((a,b)=>a.startTime-b.startTime)
					//设置下一个学期起始值
					this.endTime=this.list[this.list.length-1]?.endTime+1000
					
				} catch (error) {
					this.list = []
				}
			},
			async getAdminSemesterBatch(row){
				this.loginOpen('同步学期中...')
				try{
					let res=await this.API.get(this.API.admin.getAdminSemesterBatchSync+row.id)
					this.$message.success(res.data?.data||"同步成功")
				}catch(error){
					
				}finally{
					this.noLogin()
				}
			},
			// 提交保存
			async submitForm() {
				try {
					let params = {
						...this.form
					}
					if (params.endTime) {
						params.endTime = this.formatEndTime(params.endTime)
					}

					if (this.form.id) {
						await this.API.post(this.API.admin.putAdminSemesterUpdate, params)
						this.$message.success('修改成功')
					} else {
						await this.API.post(this.API.admin.postAdminSemesterAdd, params)
						this.$message.success('新增成功')
					}
					this.dialogVisible = false
					this.getList()
				} catch (e) {
					this.$message.error('保存失败')
				}
			},

			// 修改状态
			async updateStatus(row) {
				try {
					let res = await this.API.get(this.API.admin.getAdminSemesterDefaultCreate + row.id)
					this.$message.success(res.data.data)
				} catch (err) {}
			},
		}
	}
</script>

<style scoped>
	.subject-container {
		padding: 20px;
		background: #fff;
		min-height: calc(100vh - 60px);
	}

	.header-box {
		display: flex;
		gap: 10px;
		margin-bottom: 16px;
	}
</style>